export const COMPENSATION_VISIBILITY_CHANNEL_NAME = "compensation-visibility";